import { render, staticRenderFns } from "./ServiceDeta.vue?vue&type=template&id=d1c1848c&scoped=true"
import script from "./ServiceDeta.vue?vue&type=script&lang=js"
export * from "./ServiceDeta.vue?vue&type=script&lang=js"
import style0 from "./ServiceDeta.vue?vue&type=style&index=0&id=d1c1848c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c1848c",
  null
  
)

export default component.exports